import { useId } from "react";

/**
 * Decorative wave overlays for the sidebar footer.
 *
 * Gradient ids are generated with `useId` so mobile + desktop instances
 * (both mounted in the DOM) don’t collide — duplicate ids make
 * `fill="url(#…)"` resolve to a `display:none` SVG and paint nothing.
 */
export const NavigationArtifact = () => {
	const reactId = useId().replace(/:/g, "");
	const backGradientId = `nav-artifact-wave-back-${reactId}`;
	const frontGradientId = `nav-artifact-wave-front-${reactId}`;

	return (
		<>
			<svg
				className="pointer-events-none absolute inset-x-0 bottom-0 z-0 aspect-[360/113] w-full dark:opacity-40"
				fill="none"
				preserveAspectRatio="xMidYMax meet"
				viewBox="0 0 360 113"
				xmlns="http://www.w3.org/2000/svg"
			>
				<defs>
					<linearGradient id={backGradientId} x1="0" x2="1" y1="0" y2="0">
						<stop offset="0%" stopColor="white" stopOpacity="0.05" />
						<stop offset="100%" stopColor="white" stopOpacity="0.15" />
					</linearGradient>
				</defs>
				<path
					d="M362.127 22.3059C362.127 75.2305 362.5 117 362.5 117H-0.5L-0.499969 0C63.273 18.7206 130.23 46.1426 218.664 46.1426C290.471 46.1426 328.346 34.2928 362.127 22.3059Z"
					fill={`url(#${backGradientId})`}
				/>
			</svg>
			<svg
				className="pointer-events-none absolute inset-x-0 bottom-0 z-0 aspect-[360/113] w-full dark:opacity-40"
				fill="none"
				preserveAspectRatio="xMidYMax meet"
				viewBox="0 0 360 74"
				xmlns="http://www.w3.org/2000/svg"
			>
				<defs>
					<linearGradient id={frontGradientId} x1="0" x2="1" y1="0" y2="0">
						<stop offset="0%" stopColor="white" stopOpacity="0.05" />
						<stop offset="100%" stopColor="white" stopOpacity="0.15" />
					</linearGradient>
				</defs>
				<path
					d="M-0.5 21.2229C31.7691 34.2574 69.6769 46.4947 135.631 46.4947C257.38 46.4947 278.105 10.0081 361.5 0V83H-0.5V21.2229Z"
					fill={`url(#${frontGradientId})`}
				/>
			</svg>
		</>
	);
};
